import { UserVisibilityMode } from '../settings/types/ISiteSettingsForSiteAdmin';
import { ExtractEncryptionMode } from './SitePropertyTypes';

export function isExtractEncryptionModeEnabled(extractEncryptionMode: ExtractEncryptionMode): boolean {
  if (extractEncryptionMode === ExtractEncryptionMode.ENABLED) {
    return true;
  }
  return false;
}

export function isUserVisibilityLimited(userVisibilityMode: UserVisibilityMode): boolean {
  return userVisibilityMode === UserVisibilityMode.LIMITED;
}
